// Research (WritePage over Research & Notes): the selected note, clip, source or study page in the same editor as
// Write. The shell keeps Research's selection apart from Write's and Plan's (ProjectShell `sideOf`).
export { WritePage as component } from '../../views/WritePage.tsx';
export const room = 'research';
export const page = 'research';
export const title = 'Research';
export const help = 'research';
export const takesNode = true;
